import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg06.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Hire the Best Software Development Company Los Angeles</h2>
            </div>
            <p>
              As a leading Los Angeles software development company, we offer
              end-to-end software solutions to assess where you are and where
              you want your software to go in the future. Our extensive software
              development services allow us to provide our clients with
              innovative software solutions that significantly increase overall
              efficiency by considerable margins.
            </p>
            <p>
              Being an industry-leader software company in Los Angeles, we are
              dedicated to allowing startups & enterprises to embrace digital
              transformation to establish a sustainable future with technology.
              During our transition from a Silicon Valley startup to top
              software developers in Los Angeles, NYC, WDC, etc., we have helped
              hundreds of global businesses shift their models by fully
              embracing technological change.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Schedule A Free Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
